import React, { FunctionComponent, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import './App.css';
import { INIT_GA } from './constants/gaConstants';

import Login from './containers/login/loginContainer';

const App: FunctionComponent<any> = props => {
  const { txnId } = props.match.params;

  useEffect(() => {
    const tagManagerArgs = INIT_GA
    TagManager.initialize(tagManagerArgs)
  }, []);
  return (
    <React.Fragment>
      <Login transactionId={txnId} />
    </React.Fragment>
  )
}

export default App;
